import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Country } from '@cod-monorepo/interfaces';
import { ButtonModule, InputModule, MenuModule } from '@sag-ui';
import { tap } from 'rxjs';

@Component({
    selector: 'app-table-country-filter',
    standalone: true,
    imports: [ButtonModule, MenuModule, CommonModule, InputModule, ReactiveFormsModule],
    templateUrl: './table-country-filter.component.html'
})
export class TableCountryFilterComponent implements OnInit {
    @Input() label: string;
    @Input() selected: string[];
    @Output() selectionChange: EventEmitter<string[]> = new EventEmitter();

    public countries = Country;
    public searchControl = new FormControl<string>('');
    public searchValue = '';

    public ngOnInit(): void {
        this.initFilterChanges();
    }

    public select(value: string): void {
        if (this.selected.includes(value)) {
            this.selectionChange.emit(this.selected.filter(v => v !== value));
        } else {
            this.selectionChange.emit([...this.selected, value]);
        }
    }

    private initFilterChanges(): void {
        this.searchControl.valueChanges
            .pipe(
                tap(value => {
                    this.searchValue = value ?? '';
                })
            )
            .subscribe();
    }
}
